import { getPacketDebugString, logFormatObject, safeParse } from './delivery-monitor-utils';

export default function ({ name, evTimeout = 2000 }) {
  const packetsMap = {};
  let monitoredEventPaths = {};

  const setMonitoredEventPaths = ({ paths = {} }) => (monitoredEventPaths = paths);

  const confirmPacketReceived = (packetId) => {
    if (packetsMap[packetId] && packetsMap[packetId].timeout) {
      clearTimeout(packetsMap[packetId].timeout);

      delete packetsMap[packetId];
    }
  };

  const packMessage = (msg, { useDeliveryConfirmation = true, destination = null } = {}) => {
    if (!useDeliveryConfirmation) {
      return msg;
    }

    const packetId = `ev-${name}-${+new Date() * Math.random()}`;

    return {
      ...msg,
      transport: {
        packetId,
        destination
      }
    };
  };

  const waitFor = ({ useDeliveryConfirmation = true, stringifiedJsonMessage, onTimeout = null, path = null }) => {
    if (!useDeliveryConfirmation) {
      return;
    }

    if (!path) {
      console.log('[DELIVERY_MONITOR_ERROR] [MISSING_PATH] [PACKET_TO_WAIT_FOR]', logFormatObject({ from: name }));
      return;
    }

    if (!monitoredEventPaths[path]) {
      return;
    }

    const packet = safeParse(stringifiedJsonMessage);

    if (!packet) {
      console.log('[DELIVERY_MONITOR_ERROR] [FAILED_TO_PARSE] [PACKET_TO_WAIT_FOR]');
      return;
    }

    const { transport } = packet;

    if (!transport) {
      return;
    }

    const { packetId, destination } = transport;

    packetsMap[packetId] = {
      timeout: setTimeout(() => {
        const debugInfoToPrint = getPacketDebugString(packet);

        console.log(
          `[DELIVERY_MONITOR_ERROR] [${path}]`,
          'Failed to deliver. Packet confirmation timeouted',
          logFormatObject({ packetId, debugInfoToPrint, from: name, destination }),
          debugInfoToPrint
        );

        if (typeof onTimeout === 'function') {
          onTimeout(debugInfoToPrint);
        }

        delete packetsMap[packetId];
      }, evTimeout)
    };
  };

  const packetReceived = ({ from, message, pong, path = null }) => {
    const { transport, ...other } = message;

    if (!path) {
      console.log('[DELIVERY_MONITOR_ERROR] [PACKET_RECEIVED_MISSINNG_PATH]');
      return;
    }

    if (!transport || typeof transport !== 'object') {
      return;
    }

    const { packetId, confirmation } = transport;

    if (confirmation && confirmation.packetId) {
      confirmPacketReceived(confirmation.packetId);
    }

    if (!monitoredEventPaths[path]) {
      return;
    }

    if (packetId) {
      try {
        pong(JSON.stringify({ transport: { confirmation: { packetId } } }));
      } catch (e) {
        console.log(`[DELIVERY_MONITOR_ERROR] [FAILED_TO_SEND_BACK] [${path}]`, {
          packetId,
          to: from,
          from: name,
          err: e.message
        });
      }
    }
  };

  return {
    setMonitoredEventPaths,
    packMessage,
    waitFor,
    packetReceived
  };
}
